import { t } from 'i18next';

import { FormActions } from 'coreOld/enums';
import { IMessage } from 'coreOld/types';

import { keyExists } from './objects';

export const getNotificationMessage = (
  data,
  message: IMessage,
  formAction?: FormActions,
  isLoading = false
) => {
  const action = getActionMessage(message, formAction, keyExists(data));

  if (isLoading) {
    return t('messageActionLoading', {
      subject: message.entity,
      action,
    });
  }

  return t('messageActionSuccess', {
    subject: message.entity,
    action,
  });
};

const getActionMessage = (message: IMessage, formAction: FormActions, isEditMode: boolean) => {
  switch (formAction) {
    case FormActions.REMOVE:
      return message.removeRecord;
    case FormActions.ADD:
      return message.createRecord;
    case FormActions.UPDATE:
      return message.updateRecord;
    case FormActions.UPSERT:
      return isEditMode ? message.updateRecord : message.createRecord;
    default:
      return message.createRecord;
  }
};
